import fp from 'lodash/fp';

import { lookupTableReducer } from 'Modules/core/redux';

import { uploadsActions } from './actions';


const defaultState = {};

const actionLookup = {
    [uploadsActions.progressUpload]: (state, upload) => ({
        ...state,
        [upload.id]: upload,
    }),
    [uploadsActions.finishUpload]: (state, id) =>
        fp.pickBy(x => x.id !== id)(state),
};

export const reducer = lookupTableReducer(defaultState, actionLookup);
